export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/logs-shield.bbe44f54.svg","height":32,"width":29,"blurWidth":0,"blurHeight":0};